import { render, staticRenderFns } from "./PortalUsersAddEdit.vue?vue&type=template&id=664abf5e"
import script from "./PortalUsersAddEdit.vue?vue&type=script&lang=js"
export * from "./PortalUsersAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports